<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">edit</i>
                        </div>
                        <h4 class="card-title ">Editar</h4>
                    </div>
                    <b-form @submit="onSubmit" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <b-tabs card class="col-lg-12" v-model="tabIndex">
                                    <b-tab title="Dados do Cliente">
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="cpf_cnpj" class="bmd-label-floating">CPF/CNPJ</label>
                                                    <the-mask refs="cpf_cnpj" type="text" class="form-control" v-model="form.client.cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']" readonly=""></the-mask>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="name" class="bmd-label-floating">Nome</label>
                                                    <input refs="name" type="text" class="form-control" v-model="form.client.name" />
                                                </div>
                                            </div>
                                            <div class="col-md-4"
                                                v-if="form.client.cpf_cnpj.length <= 11">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.mother_name != ''}">
                                                    <label for="mother_name" class="bmd-label-floating">Nome da mãe</label>
                                                    <input ref="mother_name" type="text" class="form-control" v-model="form.client.mother_name" />
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 v-if="form.client.cpf_cnpj.length <= 11" class="info-text">
                                            RG
                                        </h5>
                                        <h5 v-else class="info-text">
                                            Insc. Estadual
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.registration_number != ''}">
                                                    <label for="registration_number" class="bmd-label-floating">Número</label>
                                                    <input refs="registration_number" v-numeric-only type="text" class="form-control" v-model="form.client.registration_number" />
                                                    <label for="registration_number">{{ validation.client.registration_number }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.dispatcher_registration_number != ''}">
                                                    <label for="dispatcher_registration_number" class="bmd-label-floating">Orgão Emissor</label>
                                                    <input refs="dispatcher_registration_number" type="text" class="form-control" v-model="form.client.dispatcher_registration_number" />
                                                    <label for="dispatcher_registration_number">{{ validation.client.dispatcher_registration_number }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled" >
                                                    <label for="shipment_date_registration_number" class="bmd-label-floating">Expedição</label>
                                                    <date-picker v-model="form.client.shipment_date_registration_number" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="form.client.cpf_cnpj.length <= 11" class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.nationality != ''}">
                                                    <label for="nationality" class="bmd-label-floating">Nacionalidade</label>
                                                    <input refs="nationality" type="text" class="form-control" v-model="form.client.nationality" />
                                                    <label v-if="validation.client.nationality != ''" id="nationality-error" class="error" for="nationality">{{ validation.client.nationality }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.naturality != ''}">
                                                    <label for="naturality" class="bmd-label-floating">Naturalidade</label>
                                                    <input ref="naturality" type="text" class="form-control" v-model="form.client.naturality" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="profession" class="bmd-label-floating">Estado Civil</label>
                                                    <model-select :options="marital_status"
                                                        v-model="form.client.marital_status">
                                                    </model-select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="profession" class="bmd-label-floating">Sexo</label>
                                                    <model-select :options="sexes"
                                                        v-model="form.client.sex">
                                                    </model-select>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="equity_value" class="bmd-label-floating">Valor do Patrimônio</label>
                                                    <money v-model="form.client.equity_value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.client.date_of_birth != ''}">
                                                    <label v-if="form.client.cpf_cnpj.length <= 11" for="date_of_birth" class="bmd-label-floating">Nascimento</label>
                                                    <label v-else for="date_of_birth" class="bmd-label-floating">Abertura</label>
                                                    <date-picker v-model="form.client.date_of_birth" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" :not-after="new Date()"></date-picker>
                                                    <label v-if="validation.client.date_of_birth != ''" id="date_of_birth-error" class="error" for="date_of_birth">{{ validation.client.date_of_birth }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Autoriza divulgar dados?</label>
                                                    <b-form-checkbox
                                                        id="authorize_disseminate_data"
                                                        v-model="form.client.authorize_disseminate_data"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.authorize_disseminate_data ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Pessoa politicamente exposta?</label>
                                                    <b-form-checkbox
                                                        id="pessoa_politicamente_exposta"
                                                        v-model="form.client.pessoa_politicamente_exposta"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.pessoa_politicamente_exposta ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Possui capacidade econômica/financeira?</label>
                                                    <b-form-checkbox
                                                        id="possui_capacidade_economica_financeira"
                                                        v-model="form.client.possui_capacidade_economica_financeira"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.possui_capacidade_economica_financeira ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Reconhece assinatua presente na proposta?</label>
                                                    <b-form-checkbox
                                                        id="reconhece_assinatura_presente_proposta"
                                                        v-model="form.client.reconhece_assinatura_presente_proposta"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.reconhece_assinatura_presente_proposta ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Não recebi promessa de contemplação?</label>
                                                    <b-form-checkbox
                                                        id="nao_recebeu_promessa_contemplacao"
                                                        v-model="form.client.nao_recebeu_promessa_contemplacao"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.nao_recebeu_promessa_contemplacao ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label class="bmd-label-floating">Informar eventuais alterações?</label>
                                                    <b-form-checkbox
                                                        id="ciencia_informar_alteracoes_afins"
                                                        v-model="form.client.ciencia_informar_alteracoes_afins"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.client.ciencia_informar_alteracoes_afins ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="pessoa-fisica" v-if="form.client.cpf_cnpj.length <= 11">
                                            <br />
                                            <br />
                                            <h5 class="info-text">
                                                Dados Profissionais
                                            </h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.company_name != ''}">
                                                        <label for="company_name" class="bmd-label-floating">Nome da Empresa</label>
                                                        <input ref="company_name" type="text" class="form-control" v-model="form.client.company_name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.profession != ''}">
                                                        <label for="profession" class="bmd-label-floating">Profissão</label>
                                                        <input ref="profession" type="text" class="form-control" v-model="form.client.profession" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="salary" class="bmd-label-floating">Salário</label>
                                                        <money v-model="form.client.salary" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="pessoa-juridica" v-else>
                                            <br />
                                            <br />
                                            <h5 class="info-text">
                                                Dados Empresariais
                                            </h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.activity_name != ''}">
                                                        <label for="activity_name" class="bmd-label-floating">Atividade da Empresa</label>
                                                        <input ref="activity_name" type="text" class="form-control" v-model="form.client.activity_name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="monthly_billing" class="bmd-label-floating">Faturamento Mensal</label>
                                                        <money v-model="form.client.monthly_billing" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label for="equity_value" class="bmd-label-floating">Valor do Patrimônio</label>
                                                        <money v-model="form.client.equity_value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    </div>
                                                </div>
                                            </div>
                                            <br />
                                            <h6 class="info-text">
                                                Sócios <b-button right variant="success" @click="addPartner()">Adicionar</b-button>
                                            </h6>
                                            <div class="row"
                                                v-for="(partner, key) in form.client.partners">
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': partner.name != ''}">
                                                        <label v-bind:for="'partner_name_' + key" class="bmd-label-floating">Nome</label>
                                                        <input v-bind:ref="'partner_name_' + key" type="text" class="form-control" v-model="partner.name" />
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group" v-bind:class="{'is-filled': partner.cpf_cnpj != ''}">
                                                        <label v-bind:for="'partner_name_' + key" class="bmd-label-floating">CPF/CNPJ</label>
                                                        <the-mask type="text" class="form-control" v-model="partner.cpf_cnpj" :mask="['###.###.###-##', '##.###.###/####-##']"></the-mask>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <div class="form-group bmd-form-group is-filled">
                                                        <label v-bind:for="'participation' + key" class="bmd-label-floating">Participação (%)</label>
                                                        <money v-model="partner.participation" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    </div>
                                                </div>
                                                <div class="col-md-3" v-if="key > 0">
                                                    <b-button
                                                        block
                                                        variant="danger"
                                                        @click="removePartner(partner)"
                                                        >Remover</b-button>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Dados de Contato
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.mail != ''}">
                                                    <label for="mail" class="bmd-label-floating">E-mail <span class="text-danger">*</span></label>
                                                    <input refs="mail" type="mail" class="form-control" v-model="form.client.mail" />
                                                    <label v-if="validation.client.mail != ''" id="mail-error" class="error" for="mail">{{ validation.client.mail }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.cell_phone != ''}">
                                                    <label for="cell_phone" class="bmd-label-floating">Telefone Celular <span class="text-danger">*</span></label>
                                                    <the-mask refs="cell_phone" type="text" class="form-control" v-model="form.client.cell_phone" :mask="['(##) #####-####', '(##) #####-#####']"></the-mask>
                                                    <label v-if="validation.client.cell_phone != ''" id="cell_phone-error" class="error" for="cell_phone">{{ validation.client.cell_phone }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.home_phone != ''}">
                                                    <label for="home_phone" class="bmd-label-floating">Telefone Residencial</label>
                                                    <the-mask refs="home_phone" type="text" class="form-control" v-model="form.client.home_phone" :mask="['(##) ####-####']"></the-mask>
                                                    <label v-if="validation.client.home_phone != ''" id="home_phone-error" class="error" for="home_phone">{{ validation.client.home_phone }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.commercial_phone != ''}">
                                                    <label for="commercial_phone" class="bmd-label-floating">Telefone Comercial</label>
                                                    <the-mask refs="commercial_phone" type="text" class="form-control" v-model="form.client.commercial_phone" :mask="['(##) ####-####']"></the-mask>
                                                    <label v-if="validation.client.commercial_phone != ''" id="commercial_phone-error" class="error" for="commercial_phone">{{ validation.client.commercial_phone }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Dados Bancários
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="bank_id" class="bmd-label-floating">Banco</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="banks"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.client.bank_id"
                                                        placeholder="Escolha um banco">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-9">
                                                        <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.bank_branch != '' || form.client.bank_digit_branch != ''}">
                                                            <label for="bank_branch" class="bmd-label-floating">Agência</label>
                                                            <input refs="bank_branch" type="text" v-numeric-only class="form-control" v-model="form.client.bank_branch"></input>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group bmd-form-group">
                                                            <input refs="bank_digit_branch" maxlength="5" type="text" class="form-control" v-model="form.client.bank_digit_branch"></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="row">
                                                    <div class="col-md-9">
                                                        <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client.account_number != '' || form.client.account_digit != ''}">
                                                            <label for="account_number" class="bmd-label-floating">Número da conta</label>
                                                            <input refs="account_number" type="text" v-numeric-only class="form-control" v-model="form.client.account_number"></input>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3">
                                                        <div class="form-group bmd-form-group">
                                                            <input refs="account_digit" maxlength="5" type="text" class="form-control" v-model="form.client.account_digit"></input>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">
                                            Endereço
                                        </h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_address.cep != ''}">
                                                    <label for="cep" class="bmd-label-floating">CEP <span class="text-danger">*</span></label>
                                                    <the-mask ref="cep" type="text" class="form-control" v-model="form.client_address.cep" v-on:blur.native="searchCep" :mask="'##.###-###'" />
                                                    <label v-if="validation.address.cep != ''" id="address-error" class="error" for="address">{{ validation.address.cep }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_address.address != ''}">
                                                    <label for="address" class="bmd-label-floating">Endereço</label>
                                                    <input ref="address" type="text" class="form-control" v-model="form.client_address.address" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_address.number != ''}">
                                                    <label for="number" class="bmd-label-floating">Número</label>
                                                    <input ref="number" type="text" maxlength="15" class="form-control" v-model="form.client_address.number" />
                                                    <label v-if="validation.address.number != ''" id="number-error" class="error" for="number">{{ validation.address.number }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_address.borough != '', 'has-danger' : validation.address.borough != ''}">
                                                    <label for="borough" class="bmd-label-floating">Bairro <span class="text-danger">*</span></label>
                                                    <input ref="borough" type="text" class="form-control" v-model="form.client_address.borough" />
                                                    <label v-if="validation.address.borough != ''" id="borough-error" class="error" for="borough">{{ validation.address.borough }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group bmd-form-group" v-bind:class="{'is-filled': form.client_address.complement != ''}">
                                                    <label for="complement" class="bmd-label-floating">Complemento</label>
                                                    <input ref="complement" type="text" class="form-control" v-model="form.client_address.complement" />
                                                    <label v-if="validation.address.complement != ''" id="complement-error" class="error" for="complement">{{ validation.address.complement }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger': validation.address.city.state.id != ''}">
                                                    <label for="state" class="bmd-label-floating">Estado <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="states"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.client_address.city.state.id"
                                                        @input="onSelectState">
                                                    </model-list-select>
                                                    <label v-if="validation.address.city.state.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.state.id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger': validation.address.city.id != ''}">
                                                    <label for="city" class="bmd-label-floating">Cidade <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="cities"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.client_address.city.id">
                                                    </model-list-select>
                                                    <label v-if="validation.address.city.id != ''" id="complement-error" class="error" for="complement">{{ validation.address.city.id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    </b-tab>
                                    <b-tab title="Dados da Proposta">
                                        <div class="row">
                                            <div class="col-md-5">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="salesman" class="bmd-label-floating">Vendedor</label>
                                                    <input refs="salesman" type="text" class="form-control" v-model="form.salesman.name" disabled="" />
                                                </div>
                                            </div>
                                            <div class="col-md-5">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="partner_name" class="bmd-label-floating">Nome do Parceiro</label>
                                                    <input refs="partner_name" type="text" class="form-control" v-model="form.partner_name" />
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="partner_code" class="bmd-label-floating">Código do Parceiro</label>
                                                    <input refs="partner_code" type="text" class="form-control" v-model="form.partner_code" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.physical_proposal != '', 'has-danger' : validation.physical_proposal != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Número do Contrato <span class="text-danger">*</span></label>
                                                    <input refs="physical_proposal" type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.physical_proposal" />
                                                    <label v-if="validation.physical_proposal != ''" id="physical_proposal-error" class="error" for="physical_proposal">{{ validation.physical_proposal }}</label>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.protocol != ''}">
                                                    <label form="protocol" class="bmd-label-floating">Protocolo <!--span class="text-danger">*</span--></label>
                                                    <input refs="protocol" type="text" maxlength="20" v-numeric-only class="form-control" v-model="form.protocol" />
                                                    <label v-if="validation.protocol != ''" id="protocol-error" class="error" for="physical_proposal">{{ validation.protocol }}</label>
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.type_sale_id != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Tipo de venda <!--span class="text-danger">*</span--></label>
                                                   <model-list-select
                                                        class="form-control"
                                                        :list="type_sales"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.type_sale_id"
                                                        placeholder="Não definido">
                                                    </model-list-select>
                                                    <!-- <label v-if="validation.type_sale_id != ''" id="type_sale_id-error" class="error" for="type_sale_id">{{ validation.proposal.type_sale_id }}</label> -->
                                                </div>
                                            </div>

                                            <div class="col-md-3">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.protocol != ''}">
                                                    <label form="physical_proposal" class="bmd-label-floating">Indicador de ficha<!--span class="text-danger">*</span--></label>
                                                   <model-list-select
                                                        class="form-control"
                                                        :list="users"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.user_indicate_id"
                                                        placeholder="Não possui">
                                                    </model-list-select>
                                                    <!-- <label v-if="validation.protocol != ''" id="physical_proposal-error" class="error" for="physical_proposal">{{ validation.proposal.physical_proposal }}</label> -->
                                                </div>
                                            </div>

                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.administrator_id != ''}">
                                                    <label for="administrator_id" class="bmd-label-floating">Administradora <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="administrators"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.administrator.id"
                                                        @input="loadGroups">
                                                    </model-list-select>
                                                    <label v-if="validation.administrator_id != ''" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="plan_id" class="bmd-label-floating">Opção para Plano Simples</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="optionPlans"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.option_plan"
                                                        placeholder="Não especificado">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="plan_id" class="bmd-label-floating">Plano</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="plans"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.plan_id"
                                                        placeholder="Não especificado">
                                                    </model-list-select>
                                                    <label for="plan_id">{{ validation.plan_id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.type_group_id != ''}">
                                                    <label for="type_group_id" class="bmd-label-floating">Tipo do Grupo <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="type_groups"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.type_group_id"
                                                        @input="loadGroups">
                                                    </model-list-select>
                                                    <label v-if="validation.type_group_id != ''" id="type_group_id-error" class="error" for="type_group_id">{{ validation.type_group_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.group_id != ''}">
                                                    <label for="group_id" class="bmd-label-floating">Grupo</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="groups"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.group_id"
                                                        @input="setMeetingAt(form.group_id)">
                                                    </model-list-select>
                                                    <label v-if="validation.group_id != ''" id="group_id-error" class="error" for="group_id">{{ validation.group_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.meeting_at != ''}">
                                                    <label form="meeting_at" title="Data da próxima assembléia" class="bmd-label-floating">Data da Próxima Assembléia <span class="text-danger">*</span></label>
                                                    <date-picker disabled v-model="form.meeting_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" style="width:95%"></date-picker>
                                                    <label v-if="validation.meeting_at != ''" id="meeting_at-error" class="error" for="meeting_at">{{ validation.meeting_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.first_meeting_at != ''}">
                                                    <label form="first_meeting_at" title="Data da PRIMEIRA ASSEMBLÉIA" class="bmd-label-floating">Data da PRIMEIRA ASSEMBLÉIA</label>
                                                    <date-picker v-model="form.first_meeting_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data" style="width:95%"></date-picker>
                                                    <label v-if="validation.first_meeting_at != ''" id="meeting_at-error" class="error" for="first_meeting_at">{{ validation.first_meeting_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.quota != ''}">
                                                    <label form="quota" class="bmd-label-floating">Cota (9999.9)</label>
                                                    <input refs="quota" type="text" v-numeric-only class="form-control" v-model="form.quota" />
                                                    <label v-if="validation.quota != ''" id="quota-error" class="error" for="quota">{{ validation.quota }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-2">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.meeting_number != ''}">
                                                    <label form="meeting_number" class="bmd-label-floating">Assembleia de Participação (Nº)</label>
                                                    <input refs="meeting_number" type="text" class="form-control" v-model="form.meeting_number" />
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.quota_deadline != ''}">
                                                    <label form="quota_deadline" class="bmd-label-floating">Prazo Cota</label>
                                                    <input refs="quota_deadline" type="text" class="form-control" v-model="form.quota_deadline" />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.manufacturer_id != ''}">
                                                    <label for="manufacturer_id" class="bmd-label-floating">Marca/Categoria <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="manufacturers"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.model.manufacturer_id"
                                                        @input="getDataModels">
                                                    </model-list-select>
                                                    <label v-if="validation.manufacturer_id != ''" id="manufacturer_id-error" class="error" for="manufacturer_id">{{ validation.manufacturer_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.model_id != ''}">
                                                    <label for="model_id" class="bmd-label-floating">Modelo/Bem <span class="text-danger">*</span></label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="models"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.model_id">
                                                    </model-list-select>
                                                    <label v-if="validation.model_id != ''" id="model_id-error" class="error" for="model_id">{{ validation.model_id }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="fuel_id" class="bmd-label-floating">Combustível</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="fuels"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.fuel_id">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group"
                                                     v-bind:class="{'is-filled': form.reason_acquisition != ''}">
                                                    <label form="reason_acquisition" class="bmd-label-floating">Motivo da Aquisição</label>
                                                    <input refs="reason_acquisition" type="text" class="form-control" v-model="form.reason_acquisition" />
                                                    <label v-if="validation.reason_acquisition != ''" id="reason_acquisition-error" class="error" for="reason_acquisition">{{ validation.reason_acquisition }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="condition" class="bmd-label-floating">Condição</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="conditions"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.condition">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="formation" class="bmd-label-floating">Formação</label>
                                                    <model-list-select
                                                        class="form-control"
                                                        :list="formations"
                                                        option-value="id"
                                                        option-text="name"
                                                        v-model="form.formation">
                                                    </model-list-select>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="administrate_tax" class="bmd-label-floating">Taxa Administrativa (%)</label>
                                                    <money v-model="form.administrate_tax" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.administrate_tax != ''" id="administrate_tax-error" class="error" for="administrate_tax">{{ validation.administrate_tax }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="life_insurance" class="bmd-label-floating">Seguro de Vida (%)</label>
                                                    <money v-model="form.life_insurance" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.life_insurance != ''" id="life_insurance-error" class="error" for="life_insurance">{{ validation.life_insurance }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label for="reserve_fund" class="bmd-label-floating">Fundo de Reserva (%)</label>
                                                    <money v-model="form.reserve_fund" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                    <label v-if="validation.reserve_fund != ''" id="reserve_fund-error" class="error" for="reserve_fund">{{ validation.reserve_fund }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-check bmd-form-group is-filled">
                                                    <label form="first_payment_in_billet" class="bmd-label-floating">Recibo da 1ª Parcela via boleto?</label>
                                                    <b-form-checkbox
                                                        id="first_payment_in_billet"
                                                        v-model="form.first_payment_in_billet"
                                                        :value="true"
                                                        :unchecked-value="false">
                                                        {{ form.first_payment_in_billet ? 'Sim': 'Não' }}
                                                    </b-form-checkbox>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="first_payment_value" class="bmd-label-floating">Valor recebido da 1ª Parcela</label>
                                                    <money v-model="form.first_payment_value" maxlength="12" class="form-control" v-bind="money" placeholder=""></money>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="first_payment_value" class="bmd-label-floating">Data do recebimento da 1ª Parcela</label>
                                                    <date-picker v-model="form.first_payment_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="diluted_fee_percentage" class="bmd-label-floating">Taxa Antecipada Diluída (% em parcelas)</label>
                                                    <money v-model="form.diluted_fee_percentage" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled">
                                                    <label form="installment_fee_percentage" class="bmd-label-floating">Taxa Antecipada Parcelada (%)</label>
                                                    <money v-model="form.installment_fee_percentage" maxlength="6" class="form-control" v-bind="percent" placeholder=""></money>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                                v-bind:class="{'has-danger' : validation.value != ''}">
                                                    <label form="value" class="bmd-label-floating">Valor da Carta (R$) <span class="text-danger">*</span></label>
                                                    <money v-model="form.value" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    <label v-if="validation.value != ''" id="value-error" class="error" for="value">{{ validation.value }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                                v-bind:class="{'has-danger' : validation.plot_amount != ''}">
                                                    <label for="plot_amount" class="bmd-label-floating">Valor da Parcela (R$) <span class="text-danger">*</span></label>
                                                    <money v-model="form.plot_amount" maxlength="13" class="form-control" v-bind="money" placeholder=""></money>
                                                    <label v-if="validation.plot_amount != ''" id="plot_amount-error" class="error" for="plot_amount">{{ validation.plot_amount }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                                v-bind:class="{'has-danger' : validation.number_installments != ''}">
                                                    <label for="number_installments" class="bmd-label-floating">Quant. Parcelas <span class="text-danger">*</span></label>
                                                    <money v-model="form.number_installments" maxlength="3" class="form-control" v-bind="integer" placeholder=""></money>
                                                    <label v-if="validation.number_installments != ''" id="number_installments-error" class="error" for="number_installments">{{ validation.number_installments }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.sale_at != ''}">
                                                    <label form="sale_at" class="bmd-label-floating">Data da Venda <span class="text-danger">*</span></label>
                                                    <date-picker v-model="form.sale_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.sale_at != ''" id="sale_at-error" class="error" for="sale_at">{{ validation.sale_at }}</label>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group bmd-form-group is-filled"
                                                     v-bind:class="{'has-danger' : validation.deployment_at != ''}">
                                                    <label form="deployment_at" class="bmd-label-floating">Data Alocação</label>
                                                    <date-picker v-model="form.deployment_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                    <label v-if="validation.deployment_at != ''" id="deployment_at-error" class="error" for="deployment_at">{{ validation.deployment_at }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="contemplacao" v-if="form.contemplate_at != null">
                                            <br />
                                            <h5 class="info-text">Dados da contemplação</h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-4">
                                                    <div class="form-check bmd-form-group is-filled">
                                                        <label class="bmd-label-floating">Pagou boleto?</label>
                                                        <b-form-checkbox
                                                            id="paid_billet"
                                                            v-model="form.paid_billet"
                                                            :value="true"
                                                            :unchecked-value="false">
                                                            {{ form.paid_billet ? 'Sim': 'Não' }}
                                                        </b-form-checkbox>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled"
                                                        v-bind:class="{'has-danger' : validation.contemplate_at != ''}">
                                                        <label for="cancel_at" class="bmd-label-floating">Data da Contemplação</label>
                                                        <date-picker v-model="form.contemplate_at" lang="pt-br" format="DD/MM/YYYY" placeholder="Escolha uma data"></date-picker>
                                                        <label v-if="validation.contemplate_at != ''" id="contemplate_at-error" class="error" for="contemplate_at">{{ validation.contemplate_at }}</label>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group is-filled"
                                                        v-bind:class="{'has-danger' : validation.type_contemplation != ''}">
                                                        <label for="cancel_at" class="bmd-label-floating">Tipo de Contemplação</label>
                                                        <model-list-select
                                                            class="form-control"
                                                            :list="contemplation_types"
                                                            option-value="id"
                                                            option-text="name"
                                                            v-model="form.type_contemplation">
                                                        </model-list-select>
                                                        <label v-if="validation.type_contemplation != ''" id="type_contemplation-error" class="error" for="type_contemplation">{{ validation.type_contemplation }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="faturamento" v-if="form.invoice_at != null">
                                            <br />
                                            <h5 class="info-text">Dados do Faturamento</h5>
                                            <hr />
                                            <div class="row">
                                                <div class="col-md-2">
                                                    <div class="form-check bmd-form-group is-filled">
                                                        <label form="vehicle_is_new" class="bmd-label-floating">Veículo Novo?</label>
                                                        <b-form-checkbox
                                                            id="vehicle_is_new"
                                                            v-model="form.vehicle_is_new"
                                                            :value="true"
                                                            :unchecked-value="false">
                                                            {{ form.vehicle_is_new ? 'Sim': 'Não' }}
                                                        </b-form-checkbox>
                                                    </div>
                                                </div>
                                                <div class="col-md-2">
                                                    <div class="form-check bmd-form-group is-filled">
                                                        <label form="disposal_fee_is_internal" class="bmd-label-floating">Taxa de alienação interna?</label>
                                                        <b-form-checkbox
                                                            id="disposal_fee_is_internal"
                                                            v-model="form.disposal_fee_is_internal"
                                                            :value="true"
                                                            :unchecked-value="false">
                                                            {{ form.disposal_fee_is_internal ? 'Sim': 'Não' }}
                                                        </b-form-checkbox>
                                                    </div>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group bmd-form-group"
                                                        v-bind:class="{'is-filled': form.branch_where_purchased != ''}">
                                                        <label form="branch_where_purchased" class="bmd-label-floating">Loja onde efetuou a compra</label>
                                                        <input refs="branch_where_purchased" type="text" class="form-control" v-model="form.branch_where_purchased" />
                                                        <label v-if="validation.branch_where_purchased != ''" id="branch_where_purchased-error" class="error" for="branch_where_purchased">{{ validation.branch_where_purchased }}</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <br />
                                        <h5 class="info-text">Documento</h5>
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-12">
                                                <upload-documents v-model="documents" :items="files" :upload="true" />
                                            </div>
                                        </div>
                                    </b-tab>
                                </b-tabs>
                            </div>
                        </div>
                        <div class="card-footer">
                            <form-buttons
                                v-bind:toBackAuto="true" />
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ActionService from '@/services/modules/actions.service';
    import GroupService from '@/services/modules/groups.service';
    import TypeProfileService from '@/services/modules/typeprofiles.service';
    import validation from '@/services/validations.service';
    import UploadDocuments from '@/components/elements/UploadDocuments';
    const max_number_installments = 400;

    export default {
        components: {
            'upload-documents': UploadDocuments
        },
        computed: {
            administrators: {
                set(_administrators) {

                },
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            banks: {
                set(_banks) {

                },
                get() {
                    return this.$store.state.defaults.banks;
                }
            },
            form: {
                get() {
                    var self = this;
                    self.files = [];
                    if (self.$store.state.proposals.item.documents != undefined) {
                        var documents = self.$store.state.proposals.item.documents;
                        documents.forEach(function (file, key) {
                           self.files.push({
                               id: file.id,
                               name: file.name.name,
                               size: file.name.size,
                               contentType: file.name.contentType,
                               content: file.name.content,
                               extension: file.name.extension
                           });
                       });
                    }

                    return this.$store.state.proposals.item;
                },
                set(_form) {

                }
            },
            fuels: {
                set(_fuels) {

                },
                get() {
                    return this.$store.state.fuels.itens;
                }
            },
            manufacturers: {
                set(_manufacturers) {

                },
                get() {
                    return this.$store.state.manufacturers.itens;
                }
            },
            models: {
                set(_models) {

                },
                get() {
                    return this.$store.state.models.itens;
                }
            },
            plans: {
                set(_plans) {

                },
                get() {
                    return this.$store.state.plans.itens;
                }
            },
            states: {
                set(_states) {

                },
                get() {
                    return this.$store.state.defaults.states;
                }
            },
            type_sales : {
                set(_typeSales){},
                get(){ return this.$store.state.type_sales.items; }
            },
            users : {
                set(_users){ },
                get(){ return this.$store.state.users.itens; }
            },
        },
        data() {
            return {
                cities: [],
                conditions: [
                    {id: 'Nova', name: 'Venda Nova'},
                    {id: 'Subs', name: 'Substituição'}
                ],
                contemplation_types: [
                    {
                        id: "L",
                        name: "Lance"
                    },
                    {
                        id: "S",
                        name: "Sorteio"
                    }
                ],
                documents: [],
                files: [],
                formations: [
                    {id: 'Local', name: 'Consórcio Local'},
                    {id: 'Nacional', name: 'Consórcio Nacional'}
                ],
                groups: [],
                integer: {
                    decimal: '',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
                marital_status: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'S', text: 'Solteiro'},
                    {value: 'C', text: 'Casado'},
                    {value: 'D', text: 'Divorciado'},
                    {value: 'V', text: 'Viúvo'},
                    {value: 'U', text: 'União Estável'},
                    {value: 'O', text: 'Outros'}
                ],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                optionPlans: [
                    {id: 'S7', name: 'Plano Simples (67%)'},
                    {id: 'S', name: 'Plano Simples (75%)'},
                    {id: 'I', name: 'Plano Integral (100%)'}
                ],
                percent: {
                    decimal: ',',
                    thousands: '',
                    prefix: '',
                    suffix: '',
                    precision: 2,
                    masked: false
                },
                sexes: [
                    {value: '', text: 'Selecione uma opção'},
                    {value: 'F', text: 'Feminino'},
                    {value: 'M', text: 'Masculino'},
                ],
                tabIndex: 0,
                type_groups: [
                    {id: 0, name: 'Novo Grupo'},
                    {id: 1, name: 'Grupo em Andamento'}
                ],
                uploadFiles: [],
                validation: {
                    address: {
                        address: '',
                        cep: '',
                        number: '',
                        complement: '',
                        borough: '',
                        city: {
                            id: '',
                            state: {
                                id: ''
                            }
                        }
                    },
                    client: {
                        cpf_cnpj: '',
                        name: '',
                        registration_number: '',
                        dispatcher_registration_number: '',
                        shipment_date_registration_number: '',
                        nationality: '',
                        marital_status: '',
                        profession: '',
                        sex: '',
                        date_of_birth: '',
                        authorize_disseminate_data: '',
                        mail: '',
                        cell_phone: '',
                        home_phone: '',
                        commercial_phone: '',
                    },
                    physical_proposal: '',
                    administrator_id: '',
                    plan_id: '',
                    group_id: '',
                    type_group_id: '',
                    meeting_at: '',
                    first_meeting_at: '',
                    manufacturer_id: '',
                    model_id: '',
                    reason_acquisition: '',
                    sale_at: '',
                    deployment_at: '',
                    value: '',
                    plot_amount: '',
                    number_installments: '',
                    type_contemplation: '',
                    contemplate_at: '',
                }
            };
        },
        created() {
            var self = this;

            self.getDataAdministrators();
        },
        methods: {
            onSelectState(_index) {
                this.cities = this.states[_index - 1].cities;
            },
            setMeetingAt(id){
                this.form.meeting_at = this.groups[this.groups.findIndex( obj => obj.id == id )].meeting_at;
                this.form.group_id = id;
            },
            async getData() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('proposals/get', self.$route.params.id);

                response.then(function () {
                    self.$root.$emit("onLoading");
                    setTimeout(() => {
                        self.form.sale_at = new Date(self.form.sale_at + " 23:59:59 UTC")
                        self.getDataGroups(self.form.administrator.id);
                    }, 600);
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataGroups(self.form.administrator.id);
                });
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                    self.getData();
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getData();
                });
            },
            async getDataBanks() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/banks');

                response.then(function () {
                    self.getTypeSales();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getDataFuels() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('fuels/all');

                response.then(function () {
                    self.getDataBanks();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.getDataBanks();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataGroups(_administratorId) {
                var self = this;

                self.$root.$emit("onLoading");

                const response = GroupService.getByAdministratorId(_administratorId);

                response.then(function (_groups) {
                    self.groups = _groups;
                    self.$root.$emit("onLoading");

                    self.getDataPlans(_administratorId);
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");

                    self.getDataPlans(_administratorId);
                });
            },
            async getDataManufacturers() {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('manufacturers/all');

                response.then(function () {
                    self.getDataModels(self.form.model.manufacturer.id);
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.getDataModels(self.form.model.manufacturer.id);
                    self.$root.$emit('onLoading');
                });
            },
            async getDataModels(_manufacturerId) {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('models/search', 'manufacturer_id=' + _manufacturerId);

                response.then(function () {
                    self.getDataFuels();
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.getDataFuels();
                    self.$root.$emit('onLoading');
                });
            },
            async getDataPlans(_administratorId) {
                var self = this;

                self.$root.$emit('onLoading');
                const response = self.$store.dispatch('plans/all', _administratorId);

                response.then(function () {
                    self.$root.$emit('onLoading');

                    self.getDataManufacturers();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');

                    self.getDataManufacturers();
                });
            },
            async getDataStates() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('defaults/states');

                response.then(function () {
                    var index = self.states.findIndex(state => {
                        return state.id == self.$store.state.proposals.item.client_address.city.state.id
                    })
                    self.cities = self.states[index].cities;
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getTypeSales() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('type_sales/all');

                response.then(function () {
                    self.getUsers();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getUsers() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('users/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                    self.getDataStates();
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                    self.getDataStates();
                });
            },
            loadGroups() {
                if (this.form.administrator.id != '') {
                    this.getDataGroups(this.form.administrator.id );
                }
            },
            onSubmit(_ev) {
                _ev.preventDefault();

                var self = this;
                var form = self.form;
                var valid = true;
                var validation = self.validation;

                validation.physical_proposal = "";
                validation.administrator_id = "";
                validation.plan_id = "";
                validation.manufacturer_id = "";
                validation.model_id = "";
                validation.sale_at = "";
                validation.deployment_at = "";
                validation.value = "";
                validation.plot_amount = "";
                validation.number_installments = "";

                if (form.physical_proposal == "") {
                    validation.physical_proposal = "Campo obrigatório!";
                    valid = false;
                }

                if (form.administrator.id == "") {
                    validation.administrator_id = "Campo obrigatório!";
                    valid = false;
                } else {
                    form.administrator_id = form.administrator.id
                }

                if (form.manufacturer_id == "") {
                    validation.manufacturer_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.model_id == "") {
                    validation.model_id = "Campo obrigatório!";
                    valid = false;
                }

                if (form.sale_at == "") {
                    validation.sale_at = "Campo obrigatório!";
                    valid = false;
                }

                if (form.value === 0) {
                    validation.value = "Campo obrigatório!";
                    valid = false;
                }

                if (form.plot_amount === 0) {
                    validation.plot_amount = "Campo obrigatório!";
                    valid = false;
                }

                if (form.number_installments === 0) {
                    validation.number_installments = "Campo obrigatório!";
                    valid = false;
                } else if (form.number_installments > max_number_installments) {
                    validation.number_installments = "Quant. máxima de parcelas é " + max_number_installments;
                    valid = false;
                }

                if (valid) {
                    form.documents = self.documents;

                    self.$root.$emit("onLoading");

                    delete form.observations;

                    const response = self.$store.dispatch('proposals/edit', form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Proposta atualizada com sucesso!");
                        self.$router.push({'name': 'proposals.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                    });
                }
            },
            removeFile(_indexFile) {
                this.$store.state.proposals.item.documents.splice(_indexFile, 1);
            }
        }
    };
</script>
<style scoped>
    .card-title {
        color: #3c4858;
        text-decoration: none;
    }
</style>